
import { Vue, Component, Prop } from 'vue-property-decorator'
import { sha256hex } from 'shared/util'

const PASS_HASH = '854d8b6c23fbd8db47a29149b89a3290314114534adf804484e2bcc0d785cb18'

@Component
export default class Login extends Vue {

	@Prop() value!: boolean

	showForm = false
	invalid = false
	password = ''

	async submit() {
		const hash = await sha256hex(this.password)
		if(hash === PASS_HASH) {
			this.setLoginState(true)
			this.showForm = false
		} else {
			this.invalid = true
			setTimeout(() => { this.invalid = false}, 300)
		}
		this.password = ''
	}

	setLoginState(loggedIn: boolean) {
		try {
			this.$emit('input', loggedIn)
			localStorage.setItem('ERGLoggedIn', loggedIn ? 'true' : '')
		} catch {}
	}
	get inApp() {
		return this.$route.path.includes('participant') || this.$route.path.includes('spectator')
	}

}
